//
//

import { required, email } from "vuelidate/lib/validators";
import { $http } from "@/assets/js/appFunc";
import UserList from "@/components/tasks/userList/userList.vue";
import AddEditGroupMembers from "@/components/Admin/RolesAndUsers/AddEditGroupMembers/add-edit-group-members.vue";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import AQCheckbox from "@/components/Generics/AQCheckbox/AQCheckbox.vue";
import AQInput from "../../Generics/AQInput/AQInput.vue";

export default {
    name: "UnclaimReassignModal",
    components: {
        UserList,
        AddEditGroupMembers,
        AQInput,
        AQModal,
        AQDialog,
        AQCheckbox,
        AQTooltip,
        AQCard
    },
    props: {
        taskId: { type: String, default: "" },
        reassignAction: { type: Boolean, default: false },
        unclaimAll: { type: Boolean, default: false },
        reassignAll: { type: Boolean, default: false },
        multipleTasks: { type: Array, default: () => [] },
        reassignUserList: { type: String, default: "" },
        isManager: {
            type: Boolean,
            default: false
        },
        fromAdmin: {
            type: Boolean,
            default: false
        },
        taskTypeExternal: {
            type: Boolean,
            default: false
        },
        showExternalPhone: {
            type: Boolean,
            default: false
        },
        isMobileView: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            saved: false,
            showModal: true,
            reasonInput: "",
            unclaimFailed: false,
            allUsers: true,
            userSelected: "",
            showError: false,
            selectedValues: [],
            externalEmail: "",
            externalPhone: "",
            selectedTab: "tab-external",
            done: {
                label: this.$t("generic.done"),
                disabled: false
            },
            showActionDialog: false,
            turnOffNotification: []
        };
    },

    computed: {
        isExternal() {
            return this.taskTypeExternal && this.selectedTab === "tab-external";
        },
        setValidations() {
            const defaultValidations = { reasonInput: { required } }; let customValidations = {};
            const externalEmail = { required, email };
            const externalPhone = {
                required
            };

            customValidations = this.showExternalPhone ? { externalEmail, externalPhone } : { externalEmail };
            return this.isExternal && this.reassignAction ? { ...defaultValidations, ...customValidations } : defaultValidations;
        },
        hasSave() {
            return { label: this.$t("tasks.apply") };
        },
        isMultipleTasks() {
            return this.multipleTasks && this.multipleTasks.length > 1;
        },
        dialogDetails() {
            const dialogDetails = {};
            if (this.reassignAction) {
                if (this.isMultipleTasks) {
                    dialogDetails.title = this.$tc("reports.reassignTitle", 2);
                    dialogDetails.text = this.$tc("reports.reassingMessage", 2);
                    dialogDetails.labelText = this.$t("reports.bulkCountReassign", { count: this.multipleTasks.length });
                } else {
                    dialogDetails.title = this.$tc("reports.reassignTitle", 1);
                    dialogDetails.text = this.$tc("reports.reassingMessage", 1);
                    dialogDetails.labelText = this.$t("tasks.reassignTask");
                }
            } else if (this.isMultipleTasks) {
                dialogDetails.title = this.$tc("reports.unclaimTitle", 2);
                dialogDetails.text = this.$tc("reports.unclaimMessage", 2);
                dialogDetails.labelText = this.$t("reports.bulkCountUnclaim", { count: this.multipleTasks.length });
            } else {
                dialogDetails.title = this.$tc("reports.unclaimTitle", 1);
                dialogDetails.text = this.$tc("reports.unclaimMessage", 1);
                dialogDetails.labelText = this.$t("tasks.unclaimTask");
            }
            return dialogDetails;
        }
    },
    watch: {
        selectedValues: {
            handler(newValue) {
                if (newValue && newValue.length) {
                    this.showError = false;
                }
            },
            immediate: true
        },
        multipleTasks: {
            handler(value) {
                if (value && value.length > 10) {
                    this.turnOffNotification.push("isTurnOff");
                }
            },
            immediate: true
        }
    },
    validations() {
        return this.setValidations;
    },

    methods: {
        changeTab() {
            if (this.selectedTab === "tab-external") {
                this.selectedValues = [];
            } else {
                this.externalEmail = "";
                this.externalPhone = "";
            }
            this.$v.$reset();
        },
        dialogConfirmAction(actionMessage) {
            if (actionMessage === "ok") {
                if (this.reassignAction) {
                    let url = this.reassignAll ? "/engine/task/bulkReassign" : "/engine/task/reassign"; const userIds = []; const groupIds = [];
                    let payload = { reason: this.reasonInput, activeNotifications: !this.turnOffNotification.length };
                    if (this.isExternal) {
                        url += "/external";
                        payload = { ...payload, email: this.externalEmail };
                        if (this.showExternalPhone) {
                            payload = { ...payload, phoneNo: this.externalPhone };
                        }
                    } else {
                        this.selectedValues.forEach(element => {
                            if (element.type === "GROUP") {
                                groupIds.push(element.id);
                            } else {
                                userIds.push(element.id);
                            }
                        });
                        payload = { ...payload, userIds, groupIds };
                    }

                    if (this.reassignAll) {
                        payload.taskIds = this.multipleTasks;
                    } else {
                        payload.taskId = this.taskId;
                    }
                    if (this.taskTypeExternal) {
                        delete payload.activeNotifications;
                    }
                    $http(
                        {
                            url,
                            type: "POST",
                            data: payload
                        },
                        true
                    )
                        .then(() => {
                            this.$toast.showNotify({
                                type: "success",
                                message: this.reassignAll ? this.$tc("tasks.reassignSucces", 1) : this.$tc("tasks.reassignSucces", 2)
                            });
                            this.$emit("showReassignMsg");
                            this.selectedValues = [];
                            this.showModal = false;
                            this.$emit("modalClosed");
                            this.$emit("input", false);
                        })
                        .catch();
                    this.$emit("locationReplace");
                } else {
                    const url = this.unclaimAll ? "/engine/task/bulkUnclaim" : "/engine/task/unclaim";
                    const payload = {
                        reason: this.reasonInput
                    };
                    if (this.unclaimAll) {
                        payload.taskIds = this.multipleTasks;
                    } else {
                        payload.taskId = this.taskId;
                    }
                    $http(
                        {
                            url,
                            type: "POST",
                            data: payload
                        },
                        true
                    )
                        .then(() => {
                            this.$toast.showNotify({
                                type: "success",
                                message: this.unclaimAll ? this.$tc("tasks.unclaimedSucces", 1) : this.$tc("tasks.unclaimedSucces", 2)
                            });
                            this.$emit("showUnclaimMsg");
                            this.showModal = false;
                            this.$emit("modalClosed");
                            this.$emit("input", false);
                            this.$emit("locationReplace");
                            this.$emit("input", false);
                        })
                        .catch(() => {
                            this.$emit("locationReplace");
                        });
                }
            } else {
                this.showActionDialog = false;
            }
        },
        actionsDlg($event) {
            if ($event === "primary") {
                if (!this.reassignAction) {
                    this.$v.$touch();
                    if (this.$v.$invalid) {
                        return false;
                    }
                    this.showActionDialog = true;
                } else {
                    this.$v.$touch();
                    if (!this.isExternal && !this.selectedValues.length) {
                        this.$toast.showNotify({
                            type: "error",
                            message: this.$t("tasks.errorText")
                        });
                        return false;
                    } if (this.$v.$invalid) {
                        return false;
                    }
                    this.showError = false;
                    this.showActionDialog = true;
                }
            } else {
                this.selectedValues = [];
                this.showModal = false;
                this.$emit("modalClosed");
                this.$emit("input", false);
            }
            return false;
        }
    }
};
